import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form } from "react-bootstrap";
import { Alert } from 'reactstrap';
import LoaderButton from "../components/LoaderButton";
import "./ChangePassword.css";

const schema = Yup.object({
  oldPassword: Yup.string().required("Old Password is a required field"),
  newPassword: Yup.string().required("New Password is a required field") 
  .min(8, 'Password too short - minimum length is 8 characters')
  .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, 'Password must contain a combination of lowercase, uppercase, numeric and special characters.'),
  confirmPassword: Yup.string().required("Confirm Password is a required field")
  .oneOf([Yup.ref('newPassword')], "Passwords don't match")
});

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: "",
      newPassword: "",
      isChanging: false,
      confirmPassword: "",
      alertMessage: "",
      infoMessage: ""
    };
  }

  onDismissAlert = () => this.setState({ alertMessage: "" });
  onDismissInfo = () => this.setState({ infoMessage: "" });;

  handleSubmit = async event => {
    this.setState({ isChanging: true, alertMessage: "", infoMessage: "" });
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(
        currentUser,
        event.oldPassword,
        event.newPassword
      );
      this.setState({ infoMessage: "Password successfully changed", oldPassword: "", newPassword: "", confirmPassword: ""});
    } catch (e) {
      this.setState({ alertMessage: e.message});
    }
    this.setState({ isChanging: false });
  };

  render() {
    return (
      <div className="main">
      <Formik
      validateOnChange={false}
      validationSchema={schema}
      onSubmit={this.handleSubmit}
      initialValues={{
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
      <div>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismissAlert} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <Alert color="success" isOpen={!this.state.infoMessage == ""} toggle={this.onDismissInfo} fade={false}>
          <h4 className="alert-heading">Information</h4>
          <p>{this.state.infoMessage}</p>
        </Alert>
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group controlId="oldPassword">
            <Form.Label>Old Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="oldPassword"
              value={values.oldPassword}
              placeholder="Enter old Password"
              type="password"
              onChange={handleChange}
              isInvalid={!!errors.oldPassword}
            />
            <Form.Control.Feedback type="invalid">
              {errors.oldPassword}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="newPassword"
              value={values.newPassword}
              placeholder="New Password"
              type="password"
              onChange={handleChange}
              isInvalid={!!errors.newPassword}
            />
            <Form.Control.Feedback type="invalid">
              {errors.newPassword}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="confirmPassword">  
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="confirmPassword"
              value={values.confirmPassword}
              placeholder="Confirm Password"
              onChange={handleChange}
              isInvalid={!!errors.confirmPassword}
              type="password"
            />
            <Form.Control.Feedback type="invalid">
                {errors.confirmPassword}
            </Form.Control.Feedback>
          </Form.Group>
          <LoaderButton
            block
            bsSize="small"
            type="submit"
            text="Change Password"
            loadingText="Changing…"
            disabled={!errors}
            isLoading={this.state.isChanging}
          />
        </Form>
      </div>
       )}
       </Formik></div>
     );
  }
}
